<template>
  <div>
    <PasswordRecoveryForm />
  </div>
</template>

<script>
import PasswordRecoveryForm from "@/components/auth/PasswordRecoveryForm";

export default {
  components: { PasswordRecoveryForm },
};
</script>
